/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Otp_SubmitInputs */

const he_auth_signup_otp_submit = /** @type {(inputs: Auth_Signup_Otp_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יצירת חשבון והתחברות`)
};

const en_auth_signup_otp_submit = /** @type {(inputs: Auth_Signup_Otp_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create account and sign in`)
};

/**
* | output |
* | --- |
* | "Create account and sign in" |
*
* @param {Auth_Signup_Otp_SubmitInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_otp_submit = /** @type {((inputs?: Auth_Signup_Otp_SubmitInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Otp_SubmitInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_signup_otp_submit(inputs)
	return en_auth_signup_otp_submit(inputs)
});